import React from 'react'
import card_1 from '../assets/card-top.jpg'

const Card = () => {
  return (
    <div className='w-full max-w-sm bg-white shadow-md rounded'>      
      <div className="px-6 py-4">
        <div className="font-bold text-xl mb-2">Redes Sociais</div>
        <p className="text-gray-700 text-base">
        Siga-nos também nas principais redes sociais.
        </p>
      </div>
      <div className="px-6 py-4">
      <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 my-1">#Linkedin</span>
        <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 my-1">#Instagram</span>
        <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 my-1">#Facebook</span>
        <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 my-1">#Youtube</span>
      </div>
      <img className='w-auto' src={card_1} alt='card1' />
    </div>
  )
}
export default Card